import React from 'react';
import { useI18n } from '../../_contexts/I18nContext';
import Header from '../Header';
import Banner from '../Banner/Secondary';
import Footer from '../Footer';
import styles from './index.module.scss';
import OutstandingPartners from '@/pages/business/components/OutstandingPartners';

const Container = ({
  casesData,
  dropDownData
}) => {
  const I18n = useI18n();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(Header, {
    sellerDropdownData: dropDownData.seller,
    learningDropdownData: dropDownData.learning
  }), /*#__PURE__*/React.createElement(Banner, {
    name: "Partner_ATF",
    slogan: I18n.t('tts_portal_outstanding_partners_main_title'),
    desc: I18n.t('tts_portal_outstanding_partners_main_desc'),
    img: "/images/business/banner/outstanding-partners.png",
    showButton: false
  }), /*#__PURE__*/React.createElement(OutstandingPartners, {
    cases: casesData
  }), /*#__PURE__*/React.createElement(Footer, null));
};

export default Container;